// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__354zA","container":"Footer_container__3_6ws","container__mobile":"Footer_container__mobile__3htl9","hidden":"Footer_hidden__1cGFc"};